// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../logo-full-blue.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Styles */
html {
  font-family: Arial, Helvetica, sans-serif;
  background-color: #ffffff;
}

/* Layout */
.chat-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  height: 75vh;
  min-width: 400px;
  padding: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background-color: #efefef;
  overflow-y: auto;
  max-width: 50vw;
  max-height: 100%;
  margin: 0 auto;
  position: relative;
}

.textbox-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  left: 50%; 
  transform: translateX(-50%); 
  background-color: white;
  border-top: 1px solid #ccc;
  z-index: 1;
}

/* Components */
.message {
  padding: 8px 12px;
  border-radius: 10px;
  margin: 5px;
  text-align: left;
  max-width: 80%;
}

.question {
  background-color: #32aff7;
  color: rgb(255,255,255);
  align-self: flex-end;
}

.response {
  background-color: #4e5057;
  color: rgb(255,255,255);
  align-self: flex-start;
  overflow-wrap: break-word;
}

.textbox {
  flex: 1 1;
  padding: 10px;
  border: none;
  border-radius: 20px;
  outline: none;
}

.send-button {
  background-color: #32aff7;
  color: white;
  border: none;
  border-radius: 20px;
  padding: 8px 16px;
  cursor: pointer;
  margin-left: 10px;
}

.logo {
  text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  padding: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); 
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.loading-message {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.loading-dot {
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #555;
  margin: 0 2px;
  animation: wave-bounce 1.5s infinite alternate;
}

.loading-dot:nth-child(2) {
  animation-delay: 0.2s;
}

.loading-dot:nth-child(3) {
  animation-delay: 0.4s; 
}

/* Typography */
a {
  color: #3498db;
}

a:visited {
  color: #2ecc71; 
}

a:hover {
  color: #00ff6a; 
}

a:active,
a:focus {
  color: #c3c3c3;
}

.landing-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-top: 40px;
  font-size: 16px;
  color: #333;
}

.disclaimer h1 {
  font-size: 24px;
  margin-bottom: 10px;
}

.highlights {
  display: flex;
  justify-content: center; /* Updated to center the blocks */
  margin-top: 20px;
}

.highlight {
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 10px; /* Added margin to separate the blocks */
}

.highlight .good-list {
  color: rgb(37, 178, 37);
}

.highlight .not-good-list {
  color: rgb(232, 72, 72);
}

.recent-updates {
  max-width: 745px; 
  margin: 10px auto; /* Center the block horizontally */
  text-align: center;
}

.api-key-input {
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.start-chat-button {
  margin-top: 10px;
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.start-chat-button:hover {
  background-color: #0056b3;
}

/* API Key Container */
.api-key-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* height: 40vh; */
}

.api-key-input {
  padding: 10px;
  margin: 10px 0;
  width: 300px;
  font-size: 16px;
}

.start-chat-button {
  padding: 10px 20px;
  margin: 10px;
  background-color: #007bff;
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 16px;
}

/* Animations */
@keyframes waveAnimation {
  0%, 100% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(-2px);
  }
  50% {
    transform: translateY(0);
  }
  75% {
    transform: translateY(2px);
  }
}

@keyframes wave-bounce {
  0%, 100% {
    transform: translateY(0);
  }
  25%, 75% {
    transform: translateY(-6px);
  }
  50% {
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/core.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,uBAAuB;EACvB,0BAA0B;EAC1B,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;EAC5C,aAAa;EACb,yDAA8C;EAC9C,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB,EAAE,iCAAiC;EAC1D,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,cAAc,EAAE,wCAAwC;AAC1D;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB,EAAE,kCAAkC;EACrD,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* Global Styles */\nhtml {\n  font-family: Arial, Helvetica, sans-serif;\n  background-color: #ffffff;\n}\n\n/* Layout */\n.chat-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  height: 75vh;\n  min-width: 400px;\n  padding: 20px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);\n  border-radius: 10px;\n  background-color: #efefef;\n  overflow-y: auto;\n  max-width: 50vw;\n  max-height: 100%;\n  margin: 0 auto;\n  position: relative;\n}\n\n.textbox-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  padding: 10px;\n  box-sizing: border-box;\n  position: fixed;\n  bottom: 0;\n  left: 50%; \n  transform: translateX(-50%); \n  background-color: white;\n  border-top: 1px solid #ccc;\n  z-index: 1;\n}\n\n/* Components */\n.message {\n  padding: 8px 12px;\n  border-radius: 10px;\n  margin: 5px;\n  text-align: left;\n  max-width: 80%;\n}\n\n.question {\n  background-color: #32aff7;\n  color: rgb(255,255,255);\n  align-self: flex-end;\n}\n\n.response {\n  background-color: #4e5057;\n  color: rgb(255,255,255);\n  align-self: flex-start;\n  overflow-wrap: break-word;\n}\n\n.textbox {\n  flex: 1;\n  padding: 10px;\n  border: none;\n  border-radius: 20px;\n  outline: none;\n}\n\n.send-button {\n  background-color: #32aff7;\n  color: white;\n  border: none;\n  border-radius: 20px;\n  padding: 8px 16px;\n  cursor: pointer;\n  margin-left: 10px;\n}\n\n.logo {\n  text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);\n  padding: 30px;\n  background-image: url('../logo-full-blue.png'); \n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.loading-message {\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.loading-dot {\n  display: inline-block;\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background-color: #555;\n  margin: 0 2px;\n  animation: wave-bounce 1.5s infinite alternate;\n}\n\n.loading-dot:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.loading-dot:nth-child(3) {\n  animation-delay: 0.4s; \n}\n\n/* Typography */\na {\n  color: #3498db;\n}\n\na:visited {\n  color: #2ecc71; \n}\n\na:hover {\n  color: #00ff6a; \n}\n\na:active,\na:focus {\n  color: #c3c3c3;\n}\n\n.landing-page {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin-top: 40px;\n  font-size: 16px;\n  color: #333;\n}\n\n.disclaimer h1 {\n  font-size: 24px;\n  margin-bottom: 10px;\n}\n\n.highlights {\n  display: flex;\n  justify-content: center; /* Updated to center the blocks */\n  margin-top: 20px;\n}\n\n.highlight {\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n  margin: 0 10px; /* Added margin to separate the blocks */\n}\n\n.highlight .good-list {\n  color: rgb(37, 178, 37);\n}\n\n.highlight .not-good-list {\n  color: rgb(232, 72, 72);\n}\n\n.recent-updates {\n  max-width: 745px; \n  margin: 10px auto; /* Center the block horizontally */\n  text-align: center;\n}\n\n.api-key-input {\n  padding: 8px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.start-chat-button {\n  margin-top: 10px;\n  padding: 10px 20px;\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.start-chat-button:hover {\n  background-color: #0056b3;\n}\n\n/* API Key Container */\n.api-key-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  /* height: 40vh; */\n}\n\n.api-key-input {\n  padding: 10px;\n  margin: 10px 0;\n  width: 300px;\n  font-size: 16px;\n}\n\n.start-chat-button {\n  padding: 10px 20px;\n  margin: 10px;\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n/* Animations */\n@keyframes waveAnimation {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  25% {\n    transform: translateY(-2px);\n  }\n  50% {\n    transform: translateY(0);\n  }\n  75% {\n    transform: translateY(2px);\n  }\n}\n\n@keyframes wave-bounce {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  25%, 75% {\n    transform: translateY(-6px);\n  }\n  50% {\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
